const PARALLAX_VERTICAL_SELECTOR = '[data-parallax-vertical-animation]';
const PARALLAX_VERTICAL_INIT_CLASS = 'is-init-parallax-vertical-animation';
const PARALLAX_VERTICAL_MIN_WIDTH = 1025;

let gsapDepsPromise = null;

function getParallaxVerticalEls() {
  return Array.from(document.querySelectorAll(PARALLAX_VERTICAL_SELECTOR));
}

function loadGsapDeps() {
  if (gsapDepsPromise) {
    return gsapDepsPromise;
  }

  gsapDepsPromise = Promise.all([import('gsap'), import('gsap/ScrollTrigger')])
    .then(([gsapModule, scrollTriggerModule]) => {
      const gsap = gsapModule.gsap || gsapModule.default || gsapModule;
      const ScrollTrigger =
        scrollTriggerModule.ScrollTrigger || scrollTriggerModule.default;

      gsap.registerPlugin(ScrollTrigger);

      return gsap;
    })
    .catch((error) => {
      gsapDepsPromise = null;
      throw error;
    });

  return gsapDepsPromise;
}

window.parallaxVerticalAnimation = async function parallaxVerticalAnimation() {
  if (window.innerWidth < PARALLAX_VERTICAL_MIN_WIDTH) {
    return;
  }

  const parallaxVerticalElsArr = getParallaxVerticalEls().filter(
    (el) => !el.classList.contains(PARALLAX_VERTICAL_INIT_CLASS)
  );

  if (!parallaxVerticalElsArr.length) {
    return;
  }

  const gsap = await loadGsapDeps();

  parallaxVerticalElsArr.forEach((el) => {
    el.classList.add(PARALLAX_VERTICAL_INIT_CLASS);

    const startY = 100;
    let endY = 20;

    let startTrigger = 90;
    let endTrigger = 10;

    if (el.hasAttribute('data-parallax-vertical-later-start')) {
      startTrigger = 70;
      endTrigger = 5;
      endY = 0;
    }

    const attrValue = el.getAttribute('data-parallax-vertical-animation');

    let startPosition = 10;
    let endPosition = -20;

    if (attrValue) {
      const [startStr, endStr] = attrValue.split(',');
      startPosition = parseFloat(startStr) || 0;
      endPosition = parseFloat(endStr) || 0;
    }

    gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: `top-=${startY}vh ${startTrigger}%`,
        end: `bottom+=${endY}vh ${endTrigger}%`,
        scrub: 0.85,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          const progress = self.progress;

          el.style.transform = `translateY(${gsap.utils.interpolate(
            startPosition,
            endPosition,
            progress
          )}vh)`;
        },
      },
    });
  });
};

if (!document.querySelector('.bold-loader-new')) {
  window.parallaxVerticalAnimation();
}
